export enum EnumManagerReportNotes {
  BcReport = 1,
  BacReport = 2,
}
